import BaseSlide from '../components/slide'


export default class SlideIntro extends BaseSlide{
  constructor(opts){
    super(opts);


  }
  _slide(index, dir){
    if(this.size.width == 0) this._setSize();
    if(this.state.isSliding)return;

    if(index == this.state.currentIndex)return;
    let direction = dir ? dir : 1;
    let currentIndex = this.state.currentIndex;
    this.state.isSliding = true;

    this.slides[index].classList.add('active');
    this.slides[currentIndex].classList.add('hide');
    TweenMax.set(this.slides[index], {x:this.size.width * direction, autoAlpha:0});
    TweenMax.to(this.slides[index], 0.5, {x:0, autoAlpha:1, ease:Cubic.easeOut});

   if(!this.slides[index].hasAttribute("data-type")){
    TweenMax.set(this.slides[index].querySelector('.txt-con'), {x:-50* -direction, autoAlpha:0});
    TweenMax.to(this.slides[index].querySelector('.txt-con'), 0.5, {x:0, autoAlpha:1, ease:Cubic.easeOut, delay:0.4});
   }else{
     TweenMax.set(this.slides[index].querySelector('.img'), {y:50, autoAlpha:0});
     TweenMax.to(this.slides[index].querySelector('.img'), 0.5, {y:0, autoAlpha:1, ease:Cubic.easeOut, delay:0.4});
     TweenMax.set(this.slides[index].querySelector('.txt-con'), {x:-50* -direction, autoAlpha:0});
     TweenMax.to(this.slides[index].querySelector('.txt-con'), 0.5, {x:0, autoAlpha:1, ease:Cubic.easeOut, delay:0.4});
   }
    if(!this.slides[currentIndex].hasAttribute("data-type")){
      TweenMax.to(this.slides[currentIndex].querySelector('.txt-con'), 0.25, {x:200* -direction, autoAlpha:0, ease:Cubic.easeOut});
    }else{

    }

    TweenMax.to(this.slides[currentIndex], 0.4, {x:this.size.width * -direction, autoAlpha:0, ease:Cubic.easeIn, onComplete: this._slideComplete, onCompleteParams: [this, index, currentIndex]});
    this.paginations[currentIndex].classList.remove('active')
    this.paginations[index].classList.add('active')

    this.emit('startSlide', index, currentIndex);
  }
}



// WEBPACK FOOTER //
// ./src/js/components/slideIntro.js